import qs from "query-string";
import { fetchUserData, resetFetched } from "./userData";

export const PACKAGE_UPDATED = "PACKAGE_UPDATED";

export const savePackageToUser = ({ name, trackingNumber, lockerID }) => async (
  dispatch,
  getState
) => {
  // submit package to API
  const state = getState();
  const { API_ENDPOINT, token, userID } = state.auth;

  const query = {
    name,
    token,
    lockerID,
    trackingNumber
  };

  const response = await fetch(
    `${API_ENDPOINT}/api/packages/${userID}?${qs.stringify(query)}`,
    { method: "post" }
  ).then(res => res.json());

  if (response.status <= 400) {
    dispatch(resetFetched());
    dispatch(fetchUserData());
  }
};

export const getTrackingInfo = pkg => async (dispatch, getState) => {
  // retrieve tracking info
  const { API_ENDPOINT, token } = getState().auth;
  const { tracking, status, id } = pkg;

  // fetch tracking info
  const trackingInfo = await fetch(
    `${API_ENDPOINT}/api/trackingInfo/${tracking}?token=${token}`
  ).then(res => res.json());

  // if data found, update
  return dispatch({
    type: PACKAGE_UPDATED,
    payload: {
      trackingInfo: trackingInfo.carrier_status_description
        ? trackingInfo
        : undefined,
      packageID: id,
      status
    }
  });
};
